import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/frontend/layouts/default.vue").then(m => m.default || m))
}